const Epsilon = 1e-5;

interface Pt {
  x: number;
  y: number;
}

function pt(x: number, y: number): Pt {
  return { x: x, y: y };
}

function ptEquals(pt1: Pt, pt2: Pt): boolean {
  return (
    Math.abs(pt1.x - pt2.x) <= Epsilon && Math.abs(pt1.y - pt2.y) <= Epsilon
  );
}

export { Pt, pt, ptEquals };
